import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    const year = new Date().getFullYear();

    return (
      <div className="footer">
        <p>Copyright © { year } Vaultoro Group </p>
        <p>Build Number: { process.env.REACT_APP_GIT_COMMIT_SHA }</p>
      </div>
    );
  }
}

export default withRouter(Footer);
